<template>
  <div>
    <form>
      <div class="form-group mb-3">
        <label class="form-label col-label required">{{
          $t('healthCategory.healthCategoryEn')
        }}</label>
        <input
          v-model="model.health_category_description"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('health_category_description') }"
          :placeholder="$t('healthCategory.healthCategoryEn')"
        />
        <div
          class="invalid-feedback"
          v-if="errors.has('health_category_description')"
        >
          {{ errors.first('health_category_description') }}
        </div>
      </div>
      <div class="form-group">
        <label class="form-label col-label">{{
          $t('healthCategory.healthCategoryKh')
        }}</label>
        <input
          ref="health_category_description_kh kh-font"
          v-model="model.health_category_description_kh"
          type="text"
          class="form-control kh-font"
          :placeholder="$t('healthCategory.healthCategoryKh')"
        />
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'health-category-form-create',
  props: ['edit'],
  data () {
    return {
      model: {
        health_category_id: '',
        health_category_description: '',
        health_category_description_kh: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created () {
    this.setEdit()
  },
  computed: {},
  methods: {
    async save () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'healthCategory/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    async update () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'healthCategory/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'health-category' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },
    setEdit () {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'health-category' })
    },
    clearForm () {
      this.model.health_category_description = ''
      this.model.health_category_description_kh = ''
    }
  },
  watch: {
    edit: {
      handler () {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
